import React from 'react';
import {withStore} from "../../hocs";
import {observer} from "mobx-react";
import {EnumUserType} from "../../enum/EnumUserType";
import {BreadCrumbs} from "../../components/tpl/BreadCrumbs";
import {RedirectUrl} from "../../components/RedirectUrl";
import {AdminUserLog} from "../../components/user/AdminUserLog";
import {PaginationCatalog} from "../../components/catalog/PaginationCatalog";


// @ts-ignore
@withStore
@observer
export class AdminUserLogPage extends React.Component {

    componentDidMount() {
        // @ts-ignore
        const {store} = this.props;
        store?.pageAdminUserLogStore.init();
        store.basePageStore.setBreadCrumbs([{name: 'Администрирование', url: '/admin'},{name: 'Журнал событий пользователей', url: '/admin/auth'}]).setTitleInBreadCrumbs();
        store?.componentTopSearchStore.clearSearch();
    }

    render() {
        // @ts-ignore
        const {store} = this.props;
        const {
            arData,
            onCurrentPage,
            pagination
        } = store?.pageAdminUserLogStore;
        const {
            onFilterUser,
            search
        } = store?.pageAdminUserLogStore;
        let type = store.mainStore.getUserType();
        const {onLoginRoot} = store?.authStore;
        let arItemsV = [];
        if (search.length > 2) {
            arItemsV = arData.filter((item: any) => item.search.includes(search?.toUpperCase()));
        } else {
            arItemsV = arData;
        }
        const {countPage, currentPage} = pagination;
        return (
            <>
                <RedirectUrl/>
                <div className="container">
                    <div className="breadcrumbs">
                        <div className="breadcrumbs-wrapper">
                            <BreadCrumbs/>
                        </div>
                    </div>
                    <div className="catalog-title">
                        <h1 className="catalog-title__text">Журнал событий пользователей</h1>
                    </div>
                    {[EnumUserType.adminAuth, EnumUserType.root].includes(type) ?
                        <AdminUserLog
                            onFilterUser={onFilterUser}
                            onLoginRoot={onLoginRoot}
                            arData={arItemsV}
                        />
                        : null}
                    <div className="pages order-page">
                        <PaginationCatalog
                            countPage={countPage}
                            onCurrentPage={onCurrentPage}
                            currentPage={currentPage}
                        />
                    </div>
                </div>
            </>
        )
    }
}